export default function LpSoundMix() {
  return <div />;
}
